import '../scss/forms.scss'
import './widget/focal_point'

import $ from 'jquery'

$(function() {
  // Load Picture
  //////////////////////////
  $(document).on('change', 'input[type=file].img-upload-preview', function() {
    if (this.files && this.files[0]) {
      let preview = $('div.picture-preview')
      let reader = new FileReader();
      reader.onload = (function($img) {
        return function(e) {
          $img.attr('src', e.target.result);
          $img.removeAttr('hidden');
          if (preview.length) {
            preview.find('figure img').attr('src', e.target.result)
          }
        };
      })($('#' + $(this).attr('data-target')));
      reader.readAsDataURL(this.files[0]);
    }
  }).change();
});

$(function () {
  // Show filename in bootstrap 5 file input
  //////////////////////////////////////////
  $(document).on('change', 'input[type="file"]', function(e){
    if ('files' in e.target && e.target.files.length > 0) {
      let file_name = e.target.files[0].name;
      $(this).next('label').html(file_name);
    }
  });
  // prevent double submit
  ////////////////////////
  let selector = 'form:not(.no-disabled-submit)'
  let form = $(selector)
  if (form.length) {
    let serialize = null
    $(document).on('submit', selector, function(e) {
      try {
        serialize = $(this).serialize();
      } catch (err) {console.log(err)}
      $(":submit", this).attr("disabled", "disabled");
    });
    $(document).on('change', selector + ' input', function() {
      try {
        let serialize2 = $(this).serialize()
        if (serialize !== serialize2)
          $(this).closest('form').find('button[type=submit]').removeAttr('disabled')
      } catch (err) {
        console.log(err)
      }
    });
  }
  let inputs = '#id_estimated_amount, #id_amount, #id_deposit_amount, [id^=id_amendments-][id$=-amount]'
  const $amountInputs = $(inputs);
  if ($amountInputs.length) {
    $amountInputs.attr({
      'type': 'text', 'inputmode': 'decimal'
    });
    $(document).on('input', inputs, function() {
      let $this = $(this);
      let raw = $this.val();
      // Montants stockés en IntegerField → pas de décimales acceptées.
      // Préserve uniquement le "-" en première position (avenants
      // négatifs) + les chiffres. Tout le reste (point, virgule,
      // espaces, lettres) est strippé.
      let isNegative = raw.trim().startsWith('-');
      let digits = raw.replace(/[^\d]/g, '');
      let formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      if (isNegative && formatted !== '') {
        formatted = '-' + formatted;
      } else if (isNegative) {
        formatted = '-';
      }
      $this.val(formatted);
    });
    $amountInputs.closest('form').on('submit', function() {
      $amountInputs.each(function() {
        let $this = $(this);
        $this.val($this.val().replace(/\s/g, ''));
      });
    });
  }
});
